import { render, staticRenderFns } from "./giftdatacreation.vue?vue&type=template&id=77857214&scoped=true&"
import script from "./giftdatacreation.vue?vue&type=script&lang=js&"
export * from "./giftdatacreation.vue?vue&type=script&lang=js&"
import style0 from "./giftdatacreation.vue?vue&type=style&index=0&id=77857214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77857214",
  null
  
)

export default component.exports